(function () {
  var SECTION_SELECTOR = '.oddit-section-press-carousel';
  var SWIPE_THRESHOLD = 30;
  var sectionState = new Map();

  function initCarousel(section) {
    var track = section.querySelector('[data-carousel-track]');
    var slideNodes = section.querySelectorAll('[data-carousel-slide]');
    if (!track || slideNodes.length === 0) return null;

    var slides = Array.from(slideNodes);
    var count = slides.length;
    var centerPos = Math.floor(count / 2);
    var activeIndex = 0;
    var pendingDirection = 0; /* +1 = next, -1 = prev */
    var isAnimating = false;
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Read autoplay settings from data attributes */
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;

    function getGap() {
      var s = getComputedStyle(track);
      return parseFloat(s.columnGap) || parseFloat(s.gap) || 0;
    }

    /* Reorder DOM so the active slide sits at the physical center position */
    function reorderDOM(active) {
      for (var i = -centerPos; i < count - centerPos; i++) {
        var idx = ((active + i) % count + count) % count;
        track.appendChild(slides[idx]);
      }
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('oddit-section-press-carousel__card--active', idx === active);
      });
    }

    /* Calculate translateX to center the physical center child */
    function getCenterX() {
      var carouselWidth = section.querySelector('[data-carousel]').offsetWidth;
      var children = track.children;
      var gap = getGap();
      var offset = 0;
      for (var i = 0; i < centerPos; i++) {
        offset += children[i].offsetWidth + gap;
      }
      return -offset + (carouselWidth - children[centerPos].offsetWidth) / 2;
    }

    /* Snap to center without transition */
    function snapToCenter() {
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + getCenterX() + 'px)';
      track.offsetHeight;
      track.style.transition = '';
    }

    /* Move by direction: +1 = next, -1 = prev */
    function go(direction) {
      if (isAnimating) return;

      var newIndex = ((activeIndex + direction) % count + count) % count;

      if (reducedMotion.matches) {
        activeIndex = newIndex;
        reorderDOM(activeIndex);
        snapToCenter();
        return;
      }

      isAnimating = true;
      pendingDirection = direction;

      var children = track.children;
      var gap = getGap();
      var neighborIdx = centerPos + direction;
      var shift = (children[centerPos].offsetWidth + children[neighborIdx].offsetWidth) / 2 + gap;
      track.style.transform = 'translateX(' + (getCenterX() - shift * direction) + 'px)';
    }

    function next() { go(1); }
    function prev() { go(-1); }

    function onTransitionEnd(e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      activeIndex = ((activeIndex + pendingDirection) % count + count) % count;
      pendingDirection = 0;
      reorderDOM(activeIndex);
      snapToCenter();
      isAnimating = false;
    }

    track.addEventListener('transitionend', onTransitionEnd);

    function startAutoPlay() {
      if (!autoplayEnabled) return;
      stopAutoPlay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoPlay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* Pause on hover */
    function onMouseEnter() { stopAutoPlay(); }
    function onMouseLeave() {
      if (autoplayEnabled && !reducedMotion.matches && !document.hidden) startAutoPlay();
    }

    section.addEventListener('mouseenter', onMouseEnter);
    section.addEventListener('mouseleave', onMouseLeave);

    /* Pause when tab is hidden */
    function onVisibilityChange() {
      if (document.hidden) stopAutoPlay();
      else if (autoplayEnabled && !reducedMotion.matches) startAutoPlay();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    /* Touch swipe */
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwiping = false;

    function onTouchStart(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
      stopAutoPlay();
    }

    function onTouchMove(e) {
      if (isSwiping) {
        e.preventDefault();
        return;
      }
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      /* Lock to horizontal once intent is clear */
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        isSwiping = true;
        e.preventDefault();
      }
    }

    function onTouchEnd(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (isSwiping && Math.abs(dx) > SWIPE_THRESHOLD) {
        if (dx < 0) next(); else prev();
      }
      isSwiping = false;
      if (autoplayEnabled && !reducedMotion.matches && !document.hidden) startAutoPlay();
    }

    section.addEventListener('touchstart', onTouchStart, { passive: true });
    section.addEventListener('touchmove', onTouchMove, { passive: false });
    section.addEventListener('touchend', onTouchEnd, { passive: true });

    /* Recenter on resize */
    var ro = new ResizeObserver(function () {
      if (!isAnimating) snapToCenter();
    });
    ro.observe(section);

    /* Init */
    reorderDOM(0);
    snapToCenter();
    if (autoplayEnabled && !reducedMotion.matches) startAutoPlay();

    return {
      ro: ro,
      destroy: function () {
        stopAutoPlay();
        ro.disconnect();
        track.removeEventListener('transitionend', onTransitionEnd);
        section.removeEventListener('mouseenter', onMouseEnter);
        section.removeEventListener('mouseleave', onMouseLeave);
        section.removeEventListener('touchstart', onTouchStart);
        section.removeEventListener('touchmove', onTouchMove);
        section.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('visibilitychange', onVisibilityChange);
      }
    };
  }

  function initSection(section) {
    var state = { carousel: initCarousel(section) };
    sectionState.set(section.id, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section.id);
    if (!state) return;
    if (state.carousel) state.carousel.destroy();
    sectionState.delete(section.id);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();